// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ioM3","row":"ProcedureTreatmentSummary_row__3kkc1"};